import { Box, Stack } from '@mui/material'
import { React } from 'react'
import Styles from '../style/theme'
import MenuItem from './MenuItem'

const MenuItems = [
  {
    id: 1,
    name: 'BILLS',
    icon: 'BillsIcon',
    subItems: [
      {
        id: 2,
        name: 'BILLS',
        path: '/bills',
      },
      {
        id: 5,
        name: 'BILLING REPORT',
        path: '/billing-report',
      },
    ],
  },
  {
    id: 3,
    name: 'COST EXPLORER',
    icon: 'CostExplorerIcon',
    subItems: [
      {
        id: 4,
        name: 'COST EXPLORER',
        path: '/cost-explorer',
      },
      {
        id: 6,
        name: 'COST EXPLORER REPORTS',
        path: '/cost-explorer-reports',
      },
    ],
  },
]

function Main() {
  return (
    <Stack
      sx={{
        width: '160px',
        height: '100%',
        overflowY: 'auto',
        backgroundColor: Styles.Color.SecondaryGray1,
        borderRight: `solid 0.5px ${Styles.Color.SecondaryGray2}`,
      }}>
      {MenuItems.map((item) => (
        <Box key={item.id}>
          <MenuItem name={item.name} path={item.path} icon={item.icon} />
          {item.subItems?.map((subItems) => (
            <MenuItem key={subItems.id} name={subItems.name} path={subItems.path} />
          ))}
        </Box>
      ))}
    </Stack>
  )
}

export default Main
